import { useEffect, useState } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";

const Access = ({ selectedId, mode, onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [userid, setUserId] = useState("");
  const [roleCode, setroleCode] = useState("");

  const [sdate, setSDate] = useState("");
  const [edate, setEDate] = useState("");
  const [validation, setValidation] = useState(false);
  const [userData, setUserData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [hiderule, sethiderule] = useState(false);

  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    if (hiderule === false) {
      onHide();
    }
    setRefresh(true);
    sethiderule(false);
  };

  useEffect(() => {
    const fetchAccessData = async () => {
      setLoading(true);
      if (selectedId !== "") {
        try {
          const response = await axios.get(`${apiUrl}access/id/${selectedId}`, {
            headers,
          });
          if (response.data.cd === 1) {
            toast.info(response.data.description);
          } else {
            setId(response.data.id);
            setUserId(response.data.user);
            setroleCode(response.data.roleCode);
            setEDate(response.data.edate);
            setSDate(response.data.sdate);
          }
        } catch (error) {
          alert("Some issue. Please check with Administrator..!");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAccessData();
    fetchRoleData();
    fetchUserData();
  }, [selectedId, apiUrl]);

  function clearFields() {
    setUserId("");
    setroleCode("");
    setSDate("");
    setEDate("");
  }

  const fetchUserData = async () => {
    try {
      axios.get(apiUrl + "employee", { headers }).then((response) => {
        const userOption = response.data.map((op) => ({
          value: op.empid,
          label: op.name,
        }));
        setUserData(userOption);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRoleData = async () => {
    try {
      axios.get(apiUrl + "role/distinct", { headers }).then((response) => {
        const userOption = response.data.map((op) => ({
          value: op.code,
          label: op.role,
        }));
        setRoleData(userOption);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };
  const validateFields = () => {
    let errors = {};
    const isEmpty = (value) => !value || value.trim() === "";
    const isValidDate = (date) => !isNaN(Date.parse(date));

    const isNumeric = (value) => !isNaN(value) && !isNaN(parseFloat(value));
    if (!userid) errors.userid = "User Id is required...";
    if (!roleCode) errors.roleCode = "Role Code is required...";

    if (!isEmpty(sdate)) {
      if (!isValidDate(sdate)) {
        errors.sdate = "Start Date is not a valid date.";
      }
    } else {
      errors.sdate = "Start Date is required.";
    }

    if (!isEmpty(edate)) {
      if (!isValidDate(edate)) {
        errors.edate = "End Date is not a valid date.";
      } else {
        const sdateObj = new Date(sdate);
        const edateObj = new Date(edate);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Ignore time part for comparison

        if (edateObj < sdateObj) {
          errors.edate =
            "End date should be greater than or equal to the Start Date.";
        } else if (edateObj < currentDate) {
          errors.edate = "End date cannot be before the current date.";
        }
      }
    } else {
      errors.edate = "End Date is required.";
    }

    return errors;
  };
  const handlesubmit = async () => {
    setLoading(true);
    const fieldErrors = validateFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    } else {
      if (mode === "A") {
        axios
          .post(
            apiUrl + "access",
            {
              user: userid,
              roleCode: roleCode.toString().split("-")[0],
              sdate: sdate,
              edate: edate,
            },
            { headers },
          )
          .then((response) => {
            if (response.data.cd === 1) {
              setLoading(false);
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
              sethiderule(true);
            } else {
              setLoading(false);
              setSucessMessage("Web User Created Sucessfully..");
              setTitle("✔️ Success");
              setShowSucessModal(true);
            }
          });
      } else {
        axios
          .put(
            apiUrl + "access",
            {
              id: id,
              user: userid,
              roleCode: roleCode.toString().split("-")[0],
              sdate: sdate,
              edate: edate,
            },
            { headers },
          )
          .then((response) => {
            if (response.data.cd === 1) {
              setLoading(false);
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
              sethiderule(true);
            } else {
              setLoading(false);
              setSucessMessage("Web User Update Sucessfully..");
              setTitle("✔️ Success");
              setShowSucessModal(true);
            }
          });
      }
    }
  };

  const handleUserChange = (selectedOption) => {
    if (selectedOption) {
      const selectedUserValue = selectedOption.value;
      setUserId(selectedUserValue);
      setValidation((prevState) => ({ ...prevState, userid: false }));
    } else {
      setUserId("");
      setValidation((prevState) => ({ ...prevState, userid: true }));
    }
  };

  const handleRoleChange = (selectedOption) => {
    if (selectedOption) {
      const selectedRoleValue = selectedOption.value;
      setroleCode(selectedRoleValue);
      setValidation((prevState) => ({ ...prevState, roleCode: false }));
    } else {
      setroleCode("");
      setValidation((prevState) => ({ ...prevState, roleCode: true }));
    }
  };

  useEffect(() => {
    const currentDateTime = getCurrentDateTime();
    setSDate(currentDateTime);
  }, []);

  const getCurrentDateTime = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    let hours = today.getHours();
    let minutes = today.getMinutes();

    // Append leading zeros if necessary
    if (month < 10) month = `0${month}`;
    if (day < 10) day = `0${day}`;
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handlesdateChange = (e) => {
    const selectedDate = e.target.value;
    setSDate(selectedDate);
  };

  const handleedateChange = (e) => {
    const selectedDate = e.target.value;
    if (new Date(selectedDate) < new Date(sdate)) {
      setEDate("");
    } else {
      setEDate(selectedDate);
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  if (mode === "A") {
    /*Handle Update */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />

        <div className="popupmodal-maindiv">
          <b>
            <FormGroup className="mb-3">
              <Label>User</Label>
              <Select
                isClearable
                value={userData.find((option) => option.value === userid)}
                onChange={handleUserChange}
                placeholder="Select User"
                options={userData}
                id="userid"
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("userid")}
                className={errors.userid ? "input-error" : ""}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.userid && (
                <span className="error-message">{errors.userid}</span>
              )}
            </FormGroup>
          </b>
          <b>
            <FormGroup className="mb-3">
              <Label>Role</Label>
              <Select
                isClearable
                value={roleData.find((option) => option.value === roleCode)}
                onChange={handleRoleChange}
                placeholder="Role"
                options={roleData}
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("roleCode")}
                className={errors.roleCode ? "input-error" : ""}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.roleCode && (
                <span className="error-message">{errors.roleCode}</span>
              )}
            </FormGroup>
          </b>
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <div
                  className="form-group col-lg-12"
                  style={{ marginBottom: "15px" }}
                >
                  <label>Start Date</label>
                  <input
                    required
                    type="datetime-local"
                    value={sdate}
                    onChange={handlesdateChange}
                    onMouseDown={(e) => setValidation(true)}
                    onFocus={() => handleFocus("sdate")}
                    onClick={(e) => e.target.showPicker()} // Change from onFocus to onClick
                    className={errors.sdate ? "input-error" : ""}
                    min={new Date().toISOString().split("T")[0]} // Set minimum date to current date
                  />
                  {errors.sdate && (
                    <span className="error-message">{errors.sdate}</span>
                  )}
                </div>
              </div>
            </div>
          </b>
          <b>
            <div className="form-group">
              <label>End Date</label>
              <input
                required
                value={edate}
                onChange={handleedateChange}
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("edate")}
                onClick={(e) => e.target.showPicker()} // Change from onFocus to onClick
                className={errors.edate ? "input-error" : ""}
                type="datetime-local"
                min={sdate} // Set minimum date for end date to start date
              />
              {errors.edate && (
                <span className="error-message">{errors.edate}</span>
              )}
            </div>
          </b>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
        {loading && <CustomLoader />}
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <b>
            <FormGroup className="mb-3">
              <b>
                <Label>User</Label>
              </b>
              <Select
                isClearable
                value={userData.find((option) => option.value === userid)}
                onChange={handleUserChange}
                placeholder="Select User"
                options={userData}
                id="userid"
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("userid")}
                className={errors.userid ? "input-error" : ""}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.userid && (
                <span className="error-message">{errors.userid}</span>
              )}
            </FormGroup>
          </b>

          <b>
            <FormGroup className="mb-3">
              <b>
                <Label>Role</Label>
              </b>
              <Select
                isClearable
                value={roleData.find((option) => option.value === roleCode)}
                onChange={handleRoleChange}
                placeholder="Role"
                options={roleData}
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("roleCode")}
                className={errors.roleCode ? "input-error" : ""}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.roleCode && (
                <span className="error-message">{errors.roleCode}</span>
              )}
            </FormGroup>
          </b>
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <div
                  className="form-group col-lg-12"
                  style={{ marginBottom: "15px" }}
                >
                  <label>Start Date</label>
                  <input
                    required
                    type="datetime-local"
                    value={sdate}
                    onChange={handlesdateChange}
                    onMouseDown={(e) => setValidation(true)}
                    onFocus={() => handleFocus("sdate")}
                    onClick={(e) => e.target.showPicker()} // Change from onFocus to onClick
                    className={errors.sdate ? "input-error" : ""}
                    min={new Date().toISOString().split("T")[0]} // Set minimum date to current date
                  />
                  {errors.sdate && (
                    <span className="error-message">{errors.sdate}</span>
                  )}
                </div>
              </div>
            </div>
          </b>
          <b>
            <div className="form-group">
              <label>End Date</label>
              <input
                required
                value={edate}
                onChange={handleedateChange}
                onMouseDown={(e) => setValidation(true)}
                onFocus={() => handleFocus("edate")}
                onClick={(e) => e.target.showPicker()} // Change from onFocus to onClick
                className={errors.edate ? "input-error" : ""}
                type="datetime-local"
                min={sdate} // Set minimum date for end date to start date
              />
              {errors.edate && (
                <span className="error-message">{errors.edate}</span>
              )}
            </div>
          </b>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
        {loading && <CustomLoader />}
      </>
    );
  }
};

export default Access;
